import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdministratorCompanyPane from './Company/AdministratorCompanyPane';
import AdministratorCustomerPane from './Customer/AdministratorCustomerPane';
import AdministratorSuperUserPane from './SuperUser/AdministratorSuperUserPane';
import AdministratorTranslationsPane from './Translations/AdministratorTranslationsPane';
import { SuperUserContext } from '../../../context/SuperUserContext';
import { SuperUserRole } from '../../../types/superUser';
import { Routing } from '../../../util/routes.util';
import AdministratorNotAllowedScreen from './AdministratorNotAllowedScreen';
import { Tab, Tabs } from '../../components/Tabs';
import { TypedElements } from '../../../util/types.util';

export default function AdministratorScreen() {
  const { superUser } = useContext(SuperUserContext);

  const showMyCompanies =
    superUser?.role === SuperUserRole.administrator ||
    superUser?.role === SuperUserRole.manager ||
    superUser?.role === SuperUserRole.employee ||
    superUser?.role === SuperUserRole.external;

  const showCustomers =
    superUser?.role === SuperUserRole.administrator ||
    superUser?.role === SuperUserRole.manager ||
    superUser?.role === SuperUserRole.employee;

  const showSuperUsers =
    superUser?.role === SuperUserRole.administrator ||
    superUser?.role === SuperUserRole.manager ||
    superUser?.role === SuperUserRole.employee;

  const showTranslations = !!superUser;

  const tabs: TypedElements<typeof Tab>[] = [];

  if (showMyCompanies) tabs.push(<Tab path={Routing.admin.company()} text={'My Companies'} />);
  if (showCustomers) tabs.push(<Tab path={Routing.admin.customers()} text={'Customers'} />);
  if (showSuperUsers) tabs.push(<Tab path={Routing.admin.superUsers()} text={'Super Users'} />);
  if (showTranslations) tabs.push(<Tab path={Routing.admin.translations()} text={'Translations'} />);

  if (!superUser || !tabs.length) return <AdministratorNotAllowedScreen />;

  return (
    <div className='content-t-screen flex h-full flex-col'>
      <Tabs padding>
        <>{tabs}</>
      </Tabs>
      <div className='flex-grow overflow-hidden'>
        <Routes>
          <Route path='company' element={<AdministratorCompanyPane />} />
          <Route path='customers' element={<AdministratorCustomerPane />} />
          <Route path='users' element={<AdministratorSuperUserPane />} />
          <Route path='translations' element={<AdministratorTranslationsPane />} />
          <Route path='*' element={<Navigate to={'company'} />} />
        </Routes>
      </div>
    </div>
  );
}
